import type { ReactNode } from 'react';
import { Icon } from './Icon';

export type BannerKind = 'info' | 'warn' | 'danger' | 'violet';

const M: Record<BannerKind, { bg: string; color: string; icon: string }> = {
  info: { bg: 'var(--info-soft)', color: 'var(--info)', icon: 'sparkles' },
  warn: { bg: 'var(--warn-soft)', color: 'var(--warn)', icon: 'alert-triangle' },
  danger: { bg: 'var(--danger-soft)', color: 'var(--danger)', icon: 'octagon-alert' },
  violet: { bg: 'var(--violet-soft)', color: 'var(--violet)', icon: 'wand-sparkles' },
};

export function Banner({
  kind,
  children,
  right,
  mono,
}: {
  kind: BannerKind;
  children: ReactNode;
  right?: ReactNode;
  mono?: string;
}) {
  const m = M[kind];
  return (
    <div
      style={{
        background: m.bg,
        borderRadius: 'var(--r-sm)',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
      }}
    >
      <span style={{ color: m.color, display: 'grid', marginTop: 2 }}>
        <Icon name={m.icon} size={14} />
      </span>
      <span style={{ flex: 1 }}>
        <span className="t-caption" style={{ color: m.color }}>
          {children}
        </span>
        {mono && (
          <span className="t-mono-xs dim" style={{ display: 'block', marginTop: 4 }}>
            {mono}
          </span>
        )}
      </span>
      {right}
    </div>
  );
}
